$.fn.CheckoutForm = function() {
  let self = this
  self.coupon_form_original = $('.woocommerce > .checkout_coupon')
  self.coupon_field_original = self.coupon_form_original.find('input[name="coupon_code"]')
  self.coupon_form = self.coupon_form_original.clone()
  self.coupon_field = self.coupon_form.find('input[name="coupon_code"]')

  self.initialize_coupon_code = function() {
    self.coupon_form = self.coupon_form_original.clone()
    self.coupon_field = self.coupon_form.find('input[name="coupon_code"]')
    self.coupon_field.val('')
    $('.coupon-code__toggle-link').off('click').on('click', function() {
      if (self.coupon_form.is(':visible')) {
        self.coupon_form.hide()
      } else {
        self.coupon_form.show()
        self.coupon_field.focus()
      }
      $(window).trigger('resize')
      return false
    })
    $('.place-order .checkout_coupon').replaceWith(self.coupon_form)
    self.coupon_form.on('submit', function(e) {
      e.preventDefault()
      self.coupon_field_original.val(self.coupon_field.val())
      self.coupon_form_original.submit()
      $('.woocommerce-checkout-payment, .woocommerce-checkout-review-order-table').block({
        message: null,
        overlayCSS: {
          'background-color': $('body').css('background-color'),
        },
      })
      return false
    })
  }

  self.message_added = function() {
    let message_container = $('.woocommerce-notices-wrapper').first(),
    to_append = $('.woocommerce-info, .woocommerce-error, .woocommerce-message').detach()
    if (to_append.length) {
      message_container.append(to_append)
    }
    $('.woocommerce-NoticeGroup.woocommerce-NoticeGroup-checkout').remove()
  }

  return function() {
    $(document.body).on('updated_checkout checkout_error removed_coupon_in_checkout applied_coupon_in_checkout', self.message_added);
    self.message_added()
    $(document.body).on('updated_checkout checkout_error removed_coupon_in_checkout applied_coupon_in_checkout', self.initialize_coupon_code)
    self.initialize_coupon_code()
    self.find('select').each(function() {
      $(this).Select()
    })
    $(document.body).on('click', 'a[href="#update_order"]', function() {
      $(document.body).trigger('update_checkout')
      return false
    })
    return self
  }()
}
